export default {
    account_id: {
        format: {
            pattern: /^[a-z]+[a-z0-9]{4,24}$/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            minimum: 4,
            maximum: 24,
        },
    },
    password: {
        format: {
            pattern: /^.*(?=^.{6,14}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            minimum: 6,
            maximum: 14
        },
    },
    updatePassword: {
        format: {
            pattern: /^.*(?=^.{6,14}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            minimum: 6,
            maximum: 14,
        },
    },
    confirmPassword: {
        equality: 'password',
        format: {
            pattern: /^.*(?=^.{6,14}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            minimum: 6,
            maximum: 14,
        },
    },
    company_name: {
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 64,
        },
    },
    company_business_number: {
        format: {
            pattern: /\d{10}/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 10,
        },
    },
    company_owner_name: {
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 64,
        },
    },
    company_address: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    name: {
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 64,
        },
    },
    rank: {
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 64,
        },
    },
    dept: {
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 64,
        },
    },
    email: {
        presence: {allowEmpty: false, message: 'is required'},
        email: true,
        length: {
            maximum: 64,
        },
    },
    phone_number: {
        format: {
            pattern: /^01(?:0|1|[6-9])([0-9]{3,4})([0-9]{4})$/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 11,
        },
    },
    fax_number: {
        format: {
            pattern: /^0(\d{1,2})(\d{3,4})(\d{4})$/,
        },
        presence: {allowEmpty: false, message: 'is required'},
        length: {
            maximum: 11,
        },
    },
};
